import {Stars} from "parts";
import {useTranslation} from "react-i18next";
import {LandingEnum} from "_business";

export function Comments({list, bg}) {
  const
    isLanding = [LandingEnum.accent].includes(window.landing),
    {t} =
      useTranslation(
        'common',
        {
          keyPrefix: `paywall.${isLanding ? window.landing + '.' : ''}info`
        }
      )

  // const A34 = getExperiment('A34')

  return (
    <div className={'items text-start'}>
      {
        (list || t('comments', {returnObjects: true})).map(({message, date, flag, header}, index) => {
          return (
            <div key={index} className={'item block'} style={bg ? {backgroundColor: bg} : {}}>
              <div className={'row wide'}>
                <Stars/>
                <div className={'note md fw-400'}>{date}</div>
              </div>
              <h4 className={'row sm'}>
                {
                  flag &&
                  <span style={{fontSize: 20}}>{flag}</span>
                }
                {header}
              </h4>

              <p className={'notice md'}>{message}</p>

              {
                // A34.value === 'A' &&
                // <div className={'row sm'}>
                //   <img src={require('assets/img/face/' + avatar)} alt="" width={24} height={24} className={'ava'}/>
                //   <p className={'notice small'}>{contact}</p>
                // </div>
              }
            </div>
          )
        })
      }
    </div>
  )
}